import { render } from "./GoogleLoginButton.vue?vue&type=template&id=e2a2dffa&scoped=true&ts=true"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=ts"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=ts"

import "./GoogleLoginButton.vue?vue&type=style&index=0&id=e2a2dffa&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a2dffa"]])

export default __exports__